module.exports = __webpack_public_path__ + "img/story013@2x.40ff9ba3.webp";